export default __webpack_public_path__ + "static/media/financial-service.6e6f83da.jpg";